import PortfolioModule from './containers/portfolioModule'

export {default as PortfolioModuleLayout} from './components/portfolioModuleLayout'

export default PortfolioModule
